import styled from 'styled-components';

export const StyledAppLinksContainer = styled.dl`
    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-wrap: wrap;
    width: 80%;
    margin: 20px 0;

    & dd {
        margin: 10px 15px;
    }

    & a {
        background-size: contain;
    }

    @media screen and (min-width: 577px) {
        margin: 50px 0 35px 0;
    }
`;

export const StyledAppStoreIcon = styled.a`
    display: block;
    width: 260px;
    height: 86px;
    background: url('assets/app-link-icons/app-store-icon.svg') no-repeat;

    @media screen and (min-width: 577px) {
        width: 240px;
        height: 80px;
    }
`;

export const StyledAppGalleryIcon = styled.a`
    display: block;
    width: 260px;
    height: 78px;
    background: url('assets/app-link-icons/appgallery-icon.svg') no-repeat;

    @media screen and (min-width: 577px) {
        width: 266px;
        height: 80px;
    }
`;

export const StyledGooglePlayIcon = styled.a`
    display: block;
    width: 260px;
    height: 77px;
    background: url('assets/app-link-icons/google-play-icon.svg') no-repeat;

    @media screen and (min-width: 577px) {
        width: 270px;
        height: 80px;
    }
`;

export const StyledNashStoreIcon = styled.a`
    display: block;
    width: 260px;
    height: 69px;
    background: url('assets/app-link-icons/nashstore-icon.svg') no-repeat;

    @media screen and (min-width: 577px) {
        width: 300px;
        height: 80px;
    }
`;

export const StyledRuStoreIcon = styled.a`
    display: block;
    width: 260px;
    height: 87px;
    background: url('assets/app-link-icons/rustore-icon.svg') no-repeat;

    @media screen and (min-width: 577px) {
        width: 238px;
        height: 80px;
    }
`;
